enum CustomEvents {
    ApkNavigateNextPage = 'custom:apkEvent',
    ApkPassUpdatedConfig = 'custom:apkConfigEvent',
    // Add more event names as needed, following the same pattern
}

export default CustomEvents;